export default __webpack_public_path__ + "static/media/icon-business-sm.f7d4f305.svg";